// hide-zero-prices-rise.js
(function () {
  'use strict';

  // Rise theme: price elements use varied selectors like .product-card__price, .price__regular, .product-item__price
  const PRICE_SELECTORS = [
    '.price',
    '.product-card__price',
    '.price__regular',
    '.product-item__price',
    '.card__price',
    '.product-price',
    '.product-item__price-value',
    '.money'
  ];

  const zeroPriceRegex = /(?:^|\s|\$)0(?:\.0{1,2})?\b/;

  function hideZeroPrices(root = document) {
    PRICE_SELECTORS.forEach(selector => {
      root.querySelectorAll(selector).forEach(el => {
        const txt = el.textContent?.replace(/\u00A0/g, ' ').trim();
        if (txt && zeroPriceRegex.test(txt)) {
          el.style.display = 'none';
          const priceWrapper = el.closest('.product-card, .product-item, .grid__item');
          if (priceWrapper) {
            priceWrapper.querySelectorAll(selector).forEach(inner => {
              if (zeroPriceRegex.test(inner.textContent)) inner.style.display = 'none';
            });
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => hideZeroPrices());
  window.addEventListener('load', () => hideZeroPrices());

  // Watch for dynamic changes (AJAX grids etc)
  const observer = new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.addedNodes?.length) hideZeroPrices(document);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
